<template>
    <div class="app-container">
      <div class="layout-container">
        <!-- 左侧内容区域 -->
        <div class="left-panel">
          <!-- 基本信息表格 -->
          <div class="info-section">
            <div class="section-title">基本信息</div>
            <div class="info-table">
              <div class="info-row">
                <div class="info-label">投诉编号</div>
                <div class="info-value">{{ logIdList.complaintCode || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">项目名称</div>
                <div class="info-value">{{ logIdList.projectName || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">总包单位</div>
                <div class="info-value">{{ logIdList.generalContractor || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">分包单位</div>
                <div class="info-value">{{ logIdList.subcontractor || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">投诉人姓名</div>
                <div class="info-value">{{ logIdList.userId || '-' }}</div>
                <div class="info-label">联系方式</div>
                <div class="info-value">{{ logIdList.phone || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">班组/工种</div>
                <div class="info-value">{{ logIdList.position || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">班组联系人</div>
                <div class="info-value">{{ logIdList.positionName || '-' }}</div>
                <div class="info-label">班组联系方式</div>
                <div class="info-value">{{ logIdList.positionPhone || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">欠薪金额</div>
                <div class="info-value">{{ logIdList.arrearsAmount || '-' }}元</div>
              </div>
              <div class="info-row">
                <div class="info-label">欠薪时间</div>
                <div class="info-value">{{ logIdList.wageArrearsStart || '-' }} 至 {{ logIdList.wageArrearsEnd || '-' }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">投诉来源</div>
               <div class="info-value">{{ (logIdList.complaintSource !== undefined && logIdList.complaintSource !== null ? logIdList.complaintSource : 0) === 0 ? '扫码投诉' : '-' }}</div>
                <div class="info-label">分派状态</div>
                <div class="info-value">{{ getDispatchStatusText(logIdList.assignStatus) }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">处理状态</div>
                <div class="info-value">{{ getProcessStatusText(logIdList.processStatus) }}</div>
                <div class="info-label">结案状态</div>
                <div class="info-value">{{ getCaseStatusText(logIdList.caseStatus) }}</div>
              </div>
              <div class="info-row">
                <div class="info-label">提交时间</div>
                <div class="info-value">{{ logIdList.createTime || '-' }}</div>
              </div>
              <div class="info-row full-row">
                <div class="info-label remarks">备注/补充说明</div>
                <div class="info-value remarks">{{ logIdList.remarks || '-' }}</div>
              </div>
              <div class="info-row full-row">
                <div class="info-label">附件</div>
                <div class="info-value attachments">
                  <template v-if="logIdList.attachments && logIdList.attachments.length">
                    <div class="attachment-list">
                      <div class="attachment-item" v-for="(value, index) in logIdList.attachments" :key="index">
                        <div class="boxs remarks" v-if="value.fileType === 1">
                          <img :src="value.fileUrl" alt="" />
                          <span>{{ value.fileName }}</span>
                        </div>
                        <div class="boxs" v-else-if="value.fileType === 2">
                          <img src="https://baojiuye.1haozc.com/static/img/pdf.png" alt="" />
                          <span>{{ value.fileName }}</span>
                        </div>
                        <div class="boxs" v-else-if="value.fileType === 3">
                          <img src="https://baojiuye.1haozc.com/static/img/word.png" alt="" />
                          <span>{{ value.fileName }}</span>
                        </div>
                        <div class="boxs" v-else>
                          <img :src="'https://baojiuye.1haozc.com' + value.fileUrl" alt="" />
                          <span>{{ value.fileName }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-else class="no-attachments">暂无附件</div>
                </div>
              </div>
            </div>
          </div>
  
          <!-- 处理表单 -->
          <div class="form-section">
            <div class="section-title">处理表单</div>
            <el-form ref="formRef" :model="form" :label-position="'top'" :label-width="'auto'">
              <el-form-item label="处理结果说明">
                <el-input type="textarea" v-model="form.desc" placeholder="请输入处理结果说明" :rows="4"></el-input>
              </el-form-item>
              <el-form-item label="处理状态">
                <el-select v-model="form.region" placeholder="请选择处理状态" style="width: 100%">
                  <el-option label="处理中" value="0"></el-option>
                  <el-option label="已处理" value="1"></el-option>
                </el-select>
              </el-form-item>
  
              <el-form-item label="上传附件">
                <el-upload drag multiple :http-request="handleUpload" :show-file-list="false" class="full-width-upload">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">点击上传工资支付凭证、工资表等证明材料</div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <div class="uploaded-files">
                  <div class="img-up" v-for="(item, index) in form.processFiles" :key="index">
                    <i class="el-icon-close close-icon" @click="delImgFuc(index)"></i>
                    <el-image v-if="item && (item.url.endsWith('.png') || item.url.endsWith('.jpg'))" style="width: 100px; height: 100px" :src="imageUrlprefix + item.url" :preview-src-list="[imageUrlprefix + item.url]" fit="cover" />
                    <template v-else>
                      <a :href="imageUrlprefix + item.url" target="_blank">
                        <el-image :src="imageUrlprefix + '/photo/generalFile.png'" style="width: 60px; height: 60px"></el-image>
                      </a>
                      <el-popover
                          class="box-item"
                          :content="item.url.split('/')[item.url.split('/').length - 1]"
                      >
                        <span slot="reference" class="el-text">{{item.url.split("/")[item.url.split("/").length - 1]}}</span>
                      </el-popover>
                    </template>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button size="large" @click="handleBack">取消</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 右侧内容区域 -->
        <div class="right-panel">
          <div class="section-title">处置信息</div>
          <div class="steps-container">
            <MyTimeLine :cardList="timelineData" :complaintInfo="logIdList" @handleUpdateData="handleUpdateData" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {getComplaintDetail, getRecodList, submitDisposal} from '@/api/unpaidWages/complaint'
  import { uploadFile } from '@/api/upload/upload'
  import { notifySuccess } from '@/utils/modal'
  import MyTimeLine from '@/components/myComponents/MyTimeLine/index.vue'

  export default {
    name: 'ComplaintOperation',
    components: {
      MyTimeLine
    },
    data() {
      return {
        id: '0',
        logIdList: {},
        activeStep: 1,
        timelineData: [],
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: '',
          processFiles: [],
        }
      }
    },
    mounted() {
      // 从store中获取id
      this.id = this.$store.state.attachment.currentId;
      // 使用这个id进行后续操作
      console.log(this.id);
      this.getDisposalInfo();
      this.getTimeLineData();
    },
    methods: {
      // 获取分派状态文本
      getDispatchStatusText(status) {
        const statusMap = {
          0: '未分派',
          1: '一级已分派',
          2: '二级已分派'
        };
        return statusMap[status] || '-';
      },
      
      // 获取处理状态文本
      getProcessStatusText(status) {
        const statusMap = {
          0: '未处理',
          1: '处理中',
          2: '已处理'
        };
        return statusMap[status] || '-';
      },
      
      // 获取结案状态文本
      getCaseStatusText(status) {
        const statusMap = {
          0: '未结案',
          1: '已结案'
        };
        return statusMap[status] || '-';
      },
      
      // 格式化步骤时间
      formatStepTime(time, defaultDesc) {
        if (!time) return defaultDesc;
        return `${time}<br/>${defaultDesc}`;
      },
      
      // 上传文件
      handleUpload(options) {
        let formData = new FormData();
        formData.append('file', options.file);
        formData.append('type', 'backpay_complaint_process');
        uploadFile(formData).then(res => {
          if (res.data) {
            console.log(res,"上传附件成功");
            this.form.processFiles.push(res.data);
            notifySuccess(res.msg);
          }
        });
      },
      
      // 删除图片
      delImgFuc(index) {
        this.form.processFiles.splice(index, 1);
      },
      
      handleBack() {
        // 这里可以添加取消逻辑，比如返回上一页
        this.form.desc = '';
        this.form.region = '';
        this.$router.push({
          path: '/unpaidWages/complaint/exception',
        });
      },
      
      // 提交方法
      async submitForm() {
        try {
          // 构建提交数据

          let processFiles = this.form.processFiles
          .map(item => item.url)
          .filter(Boolean)
          .join(',');
                

          const submitData = {
            complaintId: this.id,
            processExplain: this.form.desc,
            processStatus: this.form.region === '0' ? 0 : 1,
            processFiles: processFiles,
          };
          const res = await submitDisposal(submitData);
          if (res.data) {
            notifySuccess('提交成功');
            // 可以在这里添加跳转逻辑
            this.$router.push({
              path: '/unpaidWages/complaint/exception',
            });
          }
        } catch (error) {
          console.log('表单验证失败');
          return false;
        }
      },
      
      // 处理附件：将逗号分隔的字符串转换为数组格式
      processAttachments(attachments) {
        if (!attachments) {
          return [];
        }
        
        // 如果已经是数组，直接返回
        if (Array.isArray(attachments)) {
          return attachments;
        }
        
        // 如果是字符串，按逗号分割并转换为对象数组
        if (typeof attachments === 'string') {
          const urls = attachments.split(',').filter(url => url.trim());
          return urls.map(url => {
            const fileUrl = url.trim();
            const fileName = fileUrl.split('/').pop() || fileUrl;
            const fileExtension = fileName.split('.').pop()?.toLowerCase() || '';
            
            // 根据文件扩展名判断文件类型
            let fileType = 0; // 默认类型
            if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(fileExtension)) {
              fileType = 1; // 图片
            } else if (fileExtension === 'pdf') {
              fileType = 2; // PDF
            } else if (['doc', 'docx'].includes(fileExtension)) {
              fileType = 3; // Word
            }

            return {
              fileUrl: this.imageUrlprefix + fileUrl,
              fileName: fileName,
              fileType: fileType
            };
          });
        }
        
        return [];
      },
      
      // 获取投诉详情
      async getDisposalInfo() {
        const res = await getComplaintDetail({id: this.id});
        this.logIdList = res.data;
        
        // 处理附件字段：如果是逗号分隔的字符串，转换为数组格式
        if (this.logIdList.attachments) {
          this.logIdList.attachments = this.processAttachments(this.logIdList.attachments);
        }
        
        // 根据实际数据设置步骤状态
        if (this.logIdList.processStatus === 2) {
          this.activeStep = 4;
        } else if (this.logIdList.processStatus === 1) {
          this.activeStep = 3;
        } else if (this.logIdList.dispatchStatus === 1) {
          this.activeStep = 2;
        } else {
          this.activeStep = 1;
        }
      },
      
      // 获取时间线数据
      async getTimeLineData() {
        try {
          const res = await getRecodList({complaintId: this.id});
          this.timelineData = (res.data || []).map((item) => {
            return {
              ...item,
              fileList: !item.recordFileList || !item.recordFileList.length ? [] : item.recordFileList.map((file) => {
                if (typeof file === "object") return file;
                return {
                  fileName: file.split("/")[file.split("/").length - 1],
                  fileUrl: file,
                  path: file
                };
              })
            };
          });
        } catch (e) {
          console.log(e);
        }
      },
      
      // 更新数据
      handleUpdateData() {
        this.getDisposalInfo();
        this.getTimeLineData();
      }
    }
  }
  </script>
  
  <style scoped>
  .app-container {
    background: #f7f8f9;
    height: 100vh;
    overflow: hidden;
    padding: 20px;
  }

  .layout-container {
    display: flex;
    height: calc(100vh - 40px);
  }
  
  .layout-container > * {
    margin-right: 20px;
  }
  
  .layout-container > *:last-child {
    margin-right: 0;
  }

  .left-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .right-panel {
    width: 400px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .info-section,
  .form-section,
  .right-panel {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .info-section {
    margin-bottom: 20px;
  }

  .form-section {
    flex: 1;
  }

  .right-panel {
    overflow-y: auto;
  }

  .section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eaeaea;
  }

  .info-table {
    display: flex;
    border: 1px solid rgba(233, 234, 236, 1);
    flex-direction: column;
    align-items:center;
  }

  .info-row {
    width:100% ;
    display: flex;
    border-bottom: 1px solid #f0f0f0;
    justify-content: space-between;
    align-items:center;
  }

  .info-row:last-child {
    border-bottom: none;
  }

  .info-label {
    display: flex;
    align-items: center;
    justify-content: right;
    width: 120px;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    font-weight: 500;
    color: #666;
    flex-shrink: 0;
    border-right: 1px solid rgba(233, 234, 236, 1);
    background: rgba(237, 246, 252, 1);
    text-align: right;
    padding-right: 12px;
    box-sizing: border-box;
  }

  .info-value {
    flex: 1;
    color: #333;
    padding: 0 12px;
    box-sizing: border-box;
    max-height: 446px;
  }

  .info-row:not(.full-row) .info-value {
    margin-right: 20px;
  }

  .info-row:not(.full-row) .info-label:not(:first-child) {
    margin-left: 20px;
    width: 100px;
  }

  .remarks {
    min-height: 100px;
    line-height: 1.5;
    border-radius: 4px;
  }

  .attachments {
    margin-top: 8px;
  }

  .attachment-list {
    display: flex;
    flex-wrap: wrap;
  }
  
  .attachment-list > * {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  
  .attachment-list > *:last-child {
    margin-right: 0;
  }

  .attachment-item {
    width: 100px;
    text-align: center;
  }

  .boxs {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .boxs img {
    width: 80px;
    height: 80px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    object-fit: cover;
  }

  .boxs span {
    margin-top: 5px;
    font-size: 12px;
    color: #666;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .no-attachments {
    color: #999;
    font-style: italic;
  }

  .steps-container {
    padding: 10px 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-step__description {
    font-size: 14px;
    line-height: 1.5;
  }

  .uploaded-files {
    display: flex;
    flex-wrap: wrap;
  }
  
  .uploaded-files > * {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  
  .uploaded-files > *:last-child {
    margin-right: 0;
  }

  .img-up {
    width: 110px;
    height: 110px;
    position: relative;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fileIcon {
    width: 60px;
    height: 60px;
    background-image: url("~@/assets/generalFile.png");
    background-size: cover;
  }

  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 99;
    cursor: pointer;
  }

  .full-width-upload {
    width: 100%;
  }

  .full-width-upload ::v-deep .el-upload {
    width: 100%;
  }

  .full-width-upload ::v-deep .el-upload-dragger {
    width: 100%;
  }
  
  .el-text {
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  </style>
